import { z } from "zod";

export const workspaceNatsPathParamsSchema = z.object({
    workspaceId: z.string().uuid(),
});

export const organizationNatsPathParamsSchema = z.object({
    organizationId: z.string().uuid(),
});

export const organizationNatsQuerySchema = z.object({
    workspaceId: z.string().uuid().optional(),
});
